import React from 'react';
import { Container, Text, withStyles } from 'components/common';
import { RewardsIcon } from 'components/common/Svg';
import { colors } from 'theme';
import {Link} from 'react-router-dom';

const StartEarning = () => (
  <Container className="w-full flex-1" paddingHorizontal={0} paddingVertical={0}>
    <div className="flex h-full">
      <div className="flex items-center px-2 border-r" style={{ width: '120px' }}>
        <RewardsIcon className="w-full" color={colors['green-primary']} />
      </div>
      <div className="flex flex-col py-4 px-4">
        <Text title className="mb-1 text-lg">Redeem rewards</Text>
        <Text>
        You can redeem your Tomo points for cashback!
        </Text>
        <Link className="mt-2 underline text-primary cursor-pointer" to="/referrals">Learn More</Link>
      </div>
    </div>
  </Container>
);

export default withStyles(StartEarning);
